import React from "react";

const Highlight = ({ text = "", phrase = "" }) => {
  const pattern = new RegExp(`(${phrase})`, "i");
  const parts = String(text).split(pattern);

  return phrase
    ? parts.map((part, index) =>
        pattern.test(part) ? (
          <code
            key={index}
            style={{
              backgroundColor: "#0082c8",
              color: "#fff",
            }}
          >
            {part}
          </code>
        ) : (
          part
        ),
      )
    : text;
};

export default Highlight;
